<template>
  <div class="filter-container">
    <h2 v-if="!isIframe">
      Available courses
    </h2>
    <h2 v-else-if="isIframe && isFullWidth">
      {{ showCalender ? 'Choose a day' : 'Choose a course' }}
    </h2>
    <div class="filter">
      <i class="fas fa-graduation-cap" />
      <select id="course-type">
        <option value="" selected>
          All courses
        </option>
        <option
          v-for="courseType in courseTypeOptions"
          :key="courseType.id"
          :value="courseType.id"
        >
          {{ courseType.title }}
        </option>
      </select>
    </div>
    <div class="filter">
      <i class="fas fa-map" />
      <select id="state">
        <option value="" selected>
          All states/territories
        </option>
        <option
          v-for="state in stateOptions"
          :key="state[1]"
          :value="state[1]"
        >
          {{ state[0] }}
        </option>
      </select>
    </div>
    <div class="filter">
      <i class="fas fa-map-marker-alt" />
      <select id="suburb">
        <option value="">
          All suburbs
        </option>
        <option
          v-for="suburb in suburbOptions"
          :key="suburb[1]"
          :value="suburb[1]"
        >
          {{ suburb[0] }}
        </option>
      </select>
    </div>
    <div
      v-if="selectedCalendarMonth && $parent.windowWidth <= 774 && !isSmallIframe"
      id="selected-month"
      class="filter"
    >
      <div class="tdesk-neutral-medium">
        <i class="fas fa-calendar-day" />
        {{ selectedCalendarMonth }}
      </div>
    </div>

    <div v-if="showDeliveryModeFilters" class="filter">
      <i class="fa-solid fa-laptop-file" />
      <select id="delivery-mode" selected>
        <option value="">
          All delivery modes
        </option>
        <option
          v-for="deliveryMode in deliveryModeOptions"
          :key="deliveryMode['text']"
          :value="deliveryMode['value']"
        >
          {{ deliveryMode['text'] }}
        </option>
      </select>
    </div>

    <div v-if="!noSearch" id="clear-filters" class="filter">
      <div class="tdesk-brand" style="cursor: pointer" @click="clearFilters()">
        <i class="fas fa-times" />
        Clear filters
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      filterOptions: {
        type: Object,
        required: true,
      },
      selectedCalendarMonth: {
        type: String,
        required: false,
        default: undefined,
      },
      activeFilters: {
        type: Object,
        required: true,
      },
      isIframe: {
        type: Boolean,
        required: false,
      },
      isFullWidth: {
        type: Boolean,
        required: false,
      },
      showCalendar: { type: Boolean, required: false, default: true },
    },
    data() {
      return {
        courseTypeOptions: this.filterOptions.course_type_options,
        stateOptions: this.filterOptions.state_options,
        suburbOptions: this.filterOptions.suburb_options,
        deliveryModeOptions: this.filterOptions.delivery_mode_options,
        selectedCourseType: null,
        selectedOptionClickListening: false,
      };
    },
    computed: {
      noSearch() {
        if (this.activeFilters['unit_ids']) {
          return false;
        }
        if (this.activeFilters['single_date']) {
          return false;
        }
        if (this.activeFilters['state']) {
          return false;
        }
        if (this.activeFilters['suburb']) {
          return false;
        }
        if (this.activeFilters['delivery_mode']) {
          return false;
        }
        return true;
      },
      isSmallIframe() {
        return this.isIframe && !this.isFullWidth;
      },
      showDeliveryModeFilters() {
        return window.SSBCFlags?.deliveryModeFilterToggle ?? false;
      },
    },
    mounted() {
      let self = this;

      $('#state').selectize({
        onItemAdd: function (value) {
          let input = $('#state').siblings('.selectize-control').find('.selectize-input');
          self.$emit('add-to-filters', {key: 'state', value: value});
          let selectedOptions = $('#state + .selectize-control > .selectize-input + .selectize-dropdown .option.selected');
          selectedOptions.removeClass('selected');
          input.text(this.options[value].text);
          self.$emit('reload-calendar');
        },
        onInitialize: function () {
          if (!self.activeFilters.state) {
            return;
          }
          this.addItem(self.activeFilters.state);
        },
      });
      $('#suburb').selectize({
        onItemAdd: function (value) {
          let input = $('#suburb').siblings('.selectize-control').find('.selectize-input');
          self.$emit('add-to-filters', {key: 'suburb', value: value});
          let selectedOptions = $('#suburb + .selectize-control > .selectize-input + .selectize-dropdown .option.selected');
          selectedOptions.removeClass('selected');
          input.text(this.options[value].text);
          self.$emit('reload-calendar');
        },
        onInitialize: function () {
          if (!self.activeFilters.suburb) {
            return;
          }
          this.addItem(self.activeFilters.suburb);
        },
      });

      $('#delivery-mode').selectize({
        onItemAdd: function (value) {
          self.$emit('add-to-filters', {key: 'delivery_mode', value: value});
          let selectedOptions = $('#delivery-mode + .selectize-control > .selectize-input + .selectize-dropdown .option.selected');
          selectedOptions.removeClass('selected');
          self.$emit('reload-calendar');
        },
        onInitialize: function () {
          if (!self.activeFilters.delivery_mode) {
            return;
          }
          this.addItem(self.activeFilters.delivery_mode);
        },
      });

      $('#course-type').selectize({
        maxItems: null,
        openOnFocus: true,
        hideSelected: false,
        render: {
          item: function () {
            return '';
          },
        },
        onInitialize: function () {
          if (!self.activeFilters.unit_ids) {
            return;
          }
          let $select = this;
          self.activeFilters.unit_ids.forEach(function (value) {
            $select.addItem(value);
          });
        },
        onBlur() {
          if (this.items.length < 1) {
            return;
          }
          self.$emit('reload-calendar');
        },
        onItemAdd: function (value) {
          let input = $('#course-type + .selectize-control > .selectize-input');
          self.$emit('add-to-filters', {key: 'unit_ids', value: this.items});
          if (this.items.length > 1) {
            input.text(`${this.items.length} courses selected`);
            return;
          }
          return input.text(this.options[value].text);
        },
      });
    },
    methods: {
      clearFilters() {
        this.$emit('clear-filters');
      },
    },
  };
</script>
